import { FC, useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";

import { PartnerLoginForm } from "@/apps/partner/views/Login/PartnerLoginForm";
import { WelcomeScreenBackground } from "@/components/Layout/WelcomeScreen/Background/WelcomeScreenBackground";
import { HeroSection } from "@/components/Layout/WelcomeScreen/HeroSection/HeroSection";
import { WelcomeScreenFooter } from "@/components/Layout/WelcomeScreenFooter/WelcomeScreenFooter";

export const WelcomePartnerPortal: FC = () => {
  const { t } = useTranslation();

  // Prevents search engine indexing
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);
  }, []);

  return (
    <WelcomeScreenBackground>
      <div className="flex min-h-screen flex-col" data-testid="welcome-content">
        <div className="flex flex-grow flex-col px-10 md:flex-row">
          <div className="md:w-[600px] md:flex-none md:shrink-0">
            <HeroSection
              textsToAnimate={[t("partnerPortal:welcomeScreen.animationText")]}
            />
            <div className="md:max-w-[80%]">
              <p className="text-lg text-white md:text-black xs:mt-24">
                <Trans
                  t={t}
                  i18nKey="partnerPortal:welcomeScreen.descriptionText"
                  components={[
                    <a
                      key="ratesLink"
                      href={t("Content.ratesLink")}
                      className="font-semibold text-highlight-100 underline md:text-secondary-100"
                      target="_blank"
                      rel="noreferrer"
                    />,
                  ]}
                />
              </p>
            </div>
          </div>
          <div className="flex items-center justify-center md:min-w-0 md:flex-1">
            <PartnerLoginForm />
          </div>
        </div>

        <WelcomeScreenFooter
          link={t("Content.shopLink")}
          text={t("Content.products")}
          linkText={t("Content.shop")}
        />
      </div>
    </WelcomeScreenBackground>
  );
};
